import React, {useEffect, useState} from 'react';
import { useT } from '../../../../helpers/i18n';
import { faBed as faBed, faUser as faUser, faShower as faShower, faStar as fasStar, faHotel as fasHotel, faBuildings as faBuildings } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../../../../helpers/class/Checkers';
import {useDispatch, useSelector} from "react-redux";
import {fetchBuilderSettingByKey, getBedroomPricingData, getPropertyPricingData, customBuilderLabel, UPON_REQUEST_DEFAULT_LABELS} from "../../../../helpers/MethodHelper";
import {urlUseEffectParser} from "../../../../helpers/DataFetchHelper";
import {faSpinner} from "@fortawesome/pro-regular-svg-icons";
import BookingBedroomButtons from '../../property/content/columned/left/BookingBedroomButtons';
import BookingInquireChainButtons from '../../property/content/columned/left/BookingInquireChainButtons';

export default function PanelBody ( props ) {
  const t = useT();
    const isEstate = props.hasOwnProperty('isEstate') ? props.isEstate : false

    const minmimStayData = props.hasOwnProperty('minmimStayData') ? props.minmimStayData : null

    const system_type_id = props.hasOwnProperty('system_type_id')  ? props.system_type_id : null

    const classification = props.hasOwnProperty('classification')  ? props.classification : null

    const hidePriceForSingleBedroom = props.hasOwnProperty('hidePrices')  ? props.hidePrices : null

    const inquiriesActiveForSingleBedroom = props.hasOwnProperty('inquiriesActive')  ? props.inquiriesActive : null

    const {hasOpenCalendar, isNotForList  = false} = props

    const propertyType = props.hasOwnProperty('propertyType')  ? props.propertyType : null

    const isHotel = useSelector(state => state['appSettings']['isHotel'])

    const isChain = useSelector(state => state['appSettings']['isChain'])

    const labelForPropertiesWithoutPrices = customBuilderLabel(useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_properties_inquires_label')
    ), UPON_REQUEST_DEFAULT_LABELS) ?? t('property.uponRequest');

    const hidePrices = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertylist_hide_prices') == 1
    );

    const showMinimumStayNotice = minmimStayData!=undefined && minmimStayData.hasOwnProperty('minimumStayInvalid') ? minmimStayData.minimumStayInvalid : false

    const extraDaysForMinimumStay = minmimStayData!=null && minmimStayData.hasOwnProperty('extraDaysForMinimumStay') ? minmimStayData.extraDaysForMinimumStay : null

    const minimumStay = minmimStayData!=null && minmimStayData.hasOwnProperty('minimumStay') ? minmimStayData.minimumStay : null

    const paragraphClassName = (showMinimumStayNotice || !(props.minimumPrice && Checkers.isValidPositiveNumber(props.minimumPrice))) ? 'm-t-5' : 'm-t-15'

    const paragraphMinStayClassName = showMinimumStayNotice ? 'm-t-0' : 'm-t-20'

    const spanColorClassname = showMinimumStayNotice ? 'text-danger' : 'text-master'

    const dispatch = useDispatch()

    const propertyPrice = useSelector(state => getPropertyPricingData(
        props.property_id,
        state['appSettings']['propertiesPricing'],
        isChain ? 1 : fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_properties_webhotelier_prices'),
        
    ))
    const bedroomPrice = props.bedroom_prices && props.bedroom_prices.find(price => price.bedroomId == props.property_id);

    const propertiesPricingLoading = useSelector( state => state['appSettings']['propertiesPricingLoading'])

    const bedroomPricingLoading = useSelector(state => state['appSettings']['bedroomPricingLoading'])

    const showPricingLoadingHalndler = () => {
        if (isEstate) {
            return false
        }

        if (props.isHotel) {
            return bedroomPricingLoading
        }

        return   propertiesPricingLoading
    }

    const extraNightsTextHandler = () => {
        if (showMinimumStayNotice) {
            if (extraDaysForMinimumStay>1) {
                return t.plural('property.addNights', extraDaysForMinimumStay)
            } else {
                return t.plural('property.addNights', extraDaysForMinimumStay)
            }
        }

        return ''
    }

    const minimumStayTextHandler = () => {
        if (showMinimumStayNotice) {
            return t('property.minimumStayNotice', { count: minimumStay });
        }

        return ''
    }

    return (
        <>
            {
                <>
                    <div className={`Properties__body ${props?.panelBodyClass}`}>
                        <div className={`${props.bodyHrefClass ? props?.bodyHrefClass : ''}`}>
                            <p className="fw-bold text-uppercaseletter-sp-normal text-color-initial fs-12 m-0">{props.property_location}</p>
                            <h5 className="fw-bold text-color-initial m-0 cursor-pointer" onClick={props.handleShow}>{props.property_title}</h5>
                            <p className="fw-normal text-color-initial fs-16 m-0 line-clamp-1">{props.property_moto!=='null' ? props.property_moto : t('property.noMotto')}</p>
                        </div>

                        <p className={"hint-text m-b-10 text-master fs-14 " + paragraphClassName}>
                            <>
                                {
                                    !isEstate && system_type_id==1 ?
                                        <>
                                            {
                                                Checkers.isValidPositiveNumber(props.capacity) ?
                                                    <>
                                                        {props.capacity}&nbsp;<FontAwesomeIcon icon={faUser} className={'m-r-5'}/> {t.plural('property.guestsLabel', Number(props.capacity))}
                                                    </>
                                                    :
                                                    <></>
                                            }
                                        </>
                                        :
                                        <>
                                            {
                                                system_type_id==2 &&
                                                    <>
                                                        {
                                                            Checkers.isValidString(classification) ?
                                                                <>
                                                                    <FontAwesomeIcon icon={fasHotel} className={'m-r-5'}/>{propertyType}&nbsp;·&nbsp;
                                                                </>
                                                                :
                                                                <>
                                                                </>
                                                        }
                                                    </>
                                                    // :
                                                    // <>{props.areaSqm}&nbsp;m<sup>2</sup></>
                                            }
                                        </>
                                }
                            </>

                            {
                                system_type_id !== 2 && props.isHotel ? (
                                <>{props.bedrooms}&nbsp;<FontAwesomeIcon icon={faUser} className={'m-r-5'} /> {t.plural('property.guestsLabel', Number(props.bedrooms))}</>
                            ) : system_type_id !== 2 && !props.isHotel ? (
                                <>
                                    {
                                        Checkers.isValidPositiveNumber(props.bedrooms) ?
                                            <>
                                                {/* the card's `bedrooms` value is the number of beds (bedrooms are given in the description) */}
                                                &nbsp;·&nbsp;{props.bedrooms}&nbsp;<FontAwesomeIcon icon={faBed} className={'m-r-5'} />{t.plural('property.bedsLabel', Number(props.bedrooms))}
                                            </>
                                            : <></>
                                    }

                                </>
                            ) : (
                                            <>
                                                {/* &nbsp;·&nbsp; */}
                                                {Checkers.isValidString(classification) ?
                                                    <>
                                                        <FontAwesomeIcon icon={fasStar} className={'m-r-5'} />
                                                        {classification}
                                                    </> : <></>}
                                            </>
                            )
                            }
                            <>
                                {
                                    isEstate &&
                                        <>
                                            {
                                                Checkers.isValidPositiveNumber(props.bathrooms) ?
                                                    <>
                                                        &nbsp;·&nbsp;
                                                        {props.bathrooms}&nbsp;<FontAwesomeIcon icon={faShower} className={'m-r-5'}/> ({t('property.bathroomsLabel')})
                                                    </>
                                                    :
                                                    <></>
                                            }
                                        </>
                                }
                            </>
                            <>
                                {
                                    Checkers.isValidPositiveNumber(props.complexCount) ?
                                        <>
                                            {props.complexCount}&nbsp;<FontAwesomeIcon icon={faBuildings} className={'m-r-5'}/> {t('property.groupLabel')}
                                        </>
                                        :
                                        <></>
                                }
                            </>
                        </p>

                        {
                            showPricingLoadingHalndler() ?
                                <>
                                    <p className="text-right m-t-20">
                                              <span className="fs-16 text-master">
                                                <FontAwesomeIcon icon={faSpinner} spin />
                                              </span>
                                    </p>
                                </>
                                :
                                <>
                                    {
                                        !hidePrices && !isEstate ?
                                        <>
                                                {!props.isHotel && <>
                                                    {

                                                        props.availabilityStatus != undefined && props.availabilityStatus == 0 ?
                                                            <>
                                                                <p className="text-right m-t-20">
                                                                    <span className="fs-16 text-master">
                                                                        {t('property.notAvailableDates')}
                                                                    </span>
                                                                </p>
                                                            </>
                                                            :
                                                            <>
                                                                {
                                                                    props.minimumPrice && Checkers.isValidPositiveNumber(props.minimumPrice) && !hidePriceForSingleBedroom && (
                                                                        !isNotForList ||
                                                                        (propertyPrice && propertyPrice.isAvailable)
                                                                    ) ?
                                                                                <p className={"text-right " + paragraphMinStayClassName}>
                                                                            <>
                                                                                {
                                                                                    (propertyPrice != null && propertyPrice.dayOriginalPrice != propertyPrice.dayPrice&&  Checkers.isValidPositiveNumber(propertyPrice.dayOriginalPrice)) ?
                                                                                        <>
                                                                                            <span
                                                                                                className={"fs-16 " + spanColorClassname}><span
                                                                                                    className="hint-text fs-16" style={{ textDecoration: 'line-through' }}>€{propertyPrice.formattedDayOriginalPrice}</span>&nbsp;</span>
                                                                                        </>
                                                                                        : <></>
                                                                                }
                                                                            </>
                                                                            <span className={"fs-16 " + spanColorClassname}>{extraNightsTextHandler()}
                                                                                <>
                                                                                    {
                                                                                        propertyPrice == null ?
                                                                                            <span>{t('property.from')}&nbsp;</span>
                                                                                            : <></>
                                                                                    }
                                                                                </>

                                                                                <span className="bold">€
                                                                                    {
                                                                                        propertyPrice == null ?
                                                                                            parseFloat(props.minimumPrice).toFixed(0)
                                                                                            :
                                                                                            propertyPrice.formattedDayPrice
                                                                                    }
                                                                                </span>
                                                                                {t('property.perNight')}
                                                                            </span>
                                                                            <>
                                                                                {
                                                                                    propertyPrice != null && !hidePriceForSingleBedroom ?
                                                                                        <>
                                                                                            <span
                                                                                                className={"fs-16 " + spanColorClassname}>&nbsp;|&nbsp;<span
                                                                                                    className="hint-text fs-14">€{propertyPrice.formattedPrice}&nbsp;{t('property.total')}</span></span>
                                                                                        </>
                                                                                        : <></>
                                                                                }
                                                                            </>
                                                                            <span className="fs-12 text-danger block">
                                                                                {
                                                                                    minimumStayTextHandler()
                                                                                }
                                                                            </span>
                                                                        </p>
                                                                        :
                                                                        <p className="text-right m-t-5">
                                                                            {!hidePriceForSingleBedroom && <span className={"fs-16 text-master"}>
                                                                                {labelForPropertiesWithoutPrices}
                                                                            </span>}
                                                                            {!hidePriceForSingleBedroom && <span className="fs-12 text-master block">
                                                                                {t('property.mayInquire')}
                                                                            </span>}
                                                                        </p>
                                                                }
                                                            </>
                                                    }
                                                </>
                                                }

                                                {props.isHotel && !props.hideBookingActions && <>
                                                    {
                                                        props.availabilityStatus != undefined && props.availabilityStatus == 0 ?
                                                            <>
                                                                <p className="text-right m-t-20">
                                                                    <span className="fs-16 text-master">
                                                                        {t('property.notAvailableDates')}
                                                                    </span>
                                                                </p>
                                                            </>
                                                            :
                                                            <>
                                                                {bedroomPrice && bedroomPrice.price !==0 ?
                                                                    // props.minimumPrice && Checkers.isValidPositiveNumber(props.minimumPrice) ?
                                                                        <p className={"text-right " + paragraphMinStayClassName}>
                                                                            <>
                                                                                {
                                                                                    // (bedroomPrice != null && bedroomPrice.dayOriginalPrice != bedroomPrice.dayPrice && Checkers.isValidPositiveNumber(bedroomPrice.dayOriginalPrice)) ?
                                                                                        <>
                                                                                            <span
                                                                                                className={"fs-16 " + spanColorClassname}><span
                                                                                                    className="hint-text fs-16" style={{ textDecoration: 'line-through' }}>€{bedroomPrice && bedroomPrice.formattedDayOriginalPrice}</span>&nbsp;</span>
                                                                                        </>
                                                                                        // : <></>
                                                                                }
                                                                            </>
                                                                            <span className={"fs-16 " + spanColorClassname}>{extraNightsTextHandler()}
                                                                                <>
                                                                                    {
                                                                                        bedroomPrice == null ?
                                                                                            <span>{t('property.from')}&nbsp;</span>
                                                                                            : <></>
                                                                                    }
                                                                                </>

                                                                                <span className="bold">€
                                                                                    {
                                                                                        bedroomPrice == null ?
                                                                                            parseFloat(props.minimumPrice).toFixed(0)
                                                                                            :
                                                                                            bedroomPrice.formattedDayPrice
                                                                                    }
                                                                                </span>
                                                                                {t('property.perNight')}
                                                                            </span>
                                                                            <>
                                                                                {
                                                                                    bedroomPrice != null ?
                                                                                        <>
                                                                                            <span
                                                                                                className={"fs-16 " + spanColorClassname}>&nbsp;|&nbsp;<span
                                                                                                    className="hint-text fs-14">€{bedroomPrice.formattedPrice}&nbsp;{t('property.total')}</span></span>
                                                                                        </>
                                                                                        : <></>
                                                                                }
                                                                            </>
                                                                            <span className="fs-12 text-danger block">
                                                                                {
                                                                                    minimumStayTextHandler()
                                                                                }
                                                                            </span>
                                                                        </p>
                                                                        // :
                                                                        // <p className="text-right m-t-5">
                                                                        //     <span className={"fs-16 text-master"}>
                                                                        //         {labelForPropertiesWithoutPrices}
                                                                        //     </span>
                                                                        //     <span className="fs-12 text-master block">
                                                                        //         {t('property.mayInquire')}
                                                                        //     </span>
                                                                        // </p>
                                                                    : <p className={"text-right " + paragraphMinStayClassName}>
                                                                        {t('property.notAvailable')}</p>}
                                                            </>
                                                    }
                                                </>}
                                            </>
                                            :
                                            <>
                                                {
                                                    !hidePrices ?
                                                        <>
                                                            {
                                                                props.estatePrice ?
                                                                    <>
                                                                        <p className="text-right m-t-20">
                                                      <span className="fs-16 text-master">
                                                          € {props.estatePrice}
                                                      </span>
                                                                        </p>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <p className="text-right m-t-20">
                                                      <span className="fs-16 text-master">
                                                          {t('property.uponRequest')}
                                                      </span>
                                                                        </p>
                                                                    </>
                                                            }
                                                        </>
                                                        : <></>
                                                }
                                            </>
                                    }
                                    {props.isHotel && !props.hideBookingActions && <BookingBedroomButtons price={bedroomPrice && bedroomPrice.price} whRoomCode={bedroomPrice && bedroomPrice.whRoomCode} />}
                                    <div
                                        onClick={(e) => !propertyPrice && !hasOpenCalendar ? e.preventDefault() : null}
                                        style={{cursor: propertyPrice && propertyPrice.isAvailable ? "pointer" : "default"}}
                                    >
                                        {props.isChain && 
                                            <BookingInquireChainButtons 
                                                price={propertyPrice && propertyPrice.price} 
                                                whRoomCode={propertyPrice && propertyPrice.whRoomCode} 
                                                inquiriesActiveForSingleBedroom={inquiriesActiveForSingleBedroom} 
                                                hasOpenCalendar={hasOpenCalendar} 
                                                isAvailable={propertyPrice && propertyPrice.isAvailable}
                                            />
                                        }
                                    </div>
                                </>
                        }
                    </div>               
                </>
            }
        </>
    )
}
